// ============================================================
// src/api/employeeApi.js  –  Mechanic/Employee API calls
// ============================================================
// Backend: GET  /api/employees
//          GET  /api/employees/departments/list
//          GET  /api/employees/:id
//          POST /api/employees
//          PUT  /api/employees/:id
//          POST /api/employees/:id/reset-password
//          POST /api/employees/:id/toggle-lock
// ============================================================

import { apiFetch } from './apiConfig';

// GET all mechanics
// search: optional string to filter by name or EE#
export async function getEmployees(search = '') {
  const q = search ? `?search=${encodeURIComponent(search)}` : '';
  return apiFetch(`/employees${q}`);
}

// GET list of departments for dropdowns
export async function getDepartments() {
  return apiFetch('/employees/departments/list');
}

// GET single employee by id
export async function getEmployee(id) {
  return apiFetch(`/employees/${id}`);
}

// POST create a new mechanic
export async function createEmployee(data) {
  return apiFetch('/employees', {
    method: 'POST',
    body: data,
  });
}

// PUT update employee details
export async function updateEmployee(id, data) {
  return apiFetch(`/employees/${id}`, {
    method: 'PUT',
    body: data,
  });
}

// POST reset plain-text password
export async function resetPassword(id, newPassword) {
  return apiFetch(`/employees/${id}/reset-password`, {
    method: 'POST',
    body: { new_password: newPassword },
  });
}

// POST lock or unlock account
// lock: true = lock, false = unlock
export async function toggleLock(id, lock) {
  return apiFetch(`/employees/${id}/toggle-lock`, {
    method: 'POST',
    body: { lock },
  });
}
